<div class="dashboard" #exportRef>
  <app-hatch-defs></app-hatch-defs>

  <div class="dashboard-topbar">
    <div class="dashboard-range">
    <span class="range-icon">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
    </span>
    <dx-date-box
      [value]="desde"
      type="date"
      displayFormat="dd MMM yyyy"
      pickerType="calendar"
      stylingMode="filled"
      [max]="hasta"
      (onValueChanged)="onDesdeChange($event.value)">
    </dx-date-box>
    <span class="range-sep">→</span>
    <dx-date-box
      [value]="hasta"
      type="date"
      displayFormat="dd MMM yyyy"
      pickerType="calendar"
      stylingMode="filled"
      [min]="desde"
      (onValueChanged)="onHastaChange($event.value)">
    </dx-date-box>
    </div>

    <!-- Texto plano del rango, solo visible al exportar -->
    <div class="range-export">
      <span class="range-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
      </span>
      <span class="range-export-text">{{ desde | date:'dd MMM yyyy' }} → {{ hasta | date:'dd MMM yyyy' }}</span>
    </div>

    <div class="dashboard-export">
    <button class="export-btn" (click)="exportar('png')" title="Exportar imagen">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
      IMG
    </button>
    <button class="export-btn" (click)="exportar('pdf')" title="Exportar PDF">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
      PDF
    </button>
    </div>
  </div>

  <app-metricas-resumen
    [ventasDiarias]="ventasDiarias"
    [ventasAnterior]="ventasAnterior"
    [desde]="desde"
    [hasta]="hasta">
  </app-metricas-resumen>

  <app-saldo-cobrar [impagos]="impagos"></app-saldo-cobrar>

  <app-ventas-diarias-chart
    [ventasDiarias]="ventasDiarias"
    [ventasAnterior]="ventasAnterior"
    [desde]="desde"
    [hasta]="hasta">
  </app-ventas-diarias-chart>

  <div class="bottom-row">
    <app-venta-semanal
      [ventasDiarias]="ventasDiarias"
      [ventasAnterior]="ventasAnterior"
      [desde]="desde"
      [hasta]="hasta">
    </app-venta-semanal>
    <app-comparativa-dias [ventasDiarias]="ventasDiarias" [ventasAnterior]="ventasAnterior"></app-comparativa-dias>
  </div>

</div>
